import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { getUniqueId } from '../../../functions/get-unique-id';
import { BaseControlComponent } from './base-control.component';
import { HelpTextComponent } from './help-text.component';

@Component({
  selector: 'app-yes-no',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    RadioButtonModule,
    HelpTextComponent,
  ],
  template: `
    <fieldset
      class="tw-border-0 tw-p-0 tw-m-0"
      [attr.aria-required]="required ? 'true' : null"
    >
      <legend class="tw-pb-1 tw-px-0.5">
        <small class="tw-font-bold"
          >{{ label }}
          @if (required) {
            <span aria-hidden="true"> *</span>
          }
        </small>
      </legend>
      <div class="tw-flex tw-px-0.5">
        @for (option of options; track option; let index = $index) {
          <div class="tw-flex tw-items-center tw-pr-5">
            <p-radiobutton
              [inputId]="id + '-' + index"
              [value]="option.value"
              [formControl]="control"
              [name]="name"
            />
            <label [for]="id + '-' + index" class="tw-ml-2 tw-mt-0.5">{{
              option.label
            }}</label>
          </div>
        }
      </div>
    </fieldset>
    @if (showHelpText) {
      <app-help-text [control]="control" [helpText]="helpText" />
    }
  `,
  styles: ``,
})
export class YesNoComponent extends BaseControlComponent {
  protected options = [
    {
      label: 'Yes',
      value: true,
    },
    {
      label: 'No',
      value: false,
    },
  ];

  protected name = getUniqueId('app-yes-no');
}
